import { useSpring } from '@react-spring/web';
import React, { useEffect } from 'react';
import cx from 'classnames';
import { StyledStat, StyledStatHelpText, StyledStatNumber } from './styles';
const arrows = {
    danger: '+',
    success: '-',
};
export const StatNumber = (props) => {
    const [styles, api] = useSpring(() => ({ value: 0 }));
    const formatter = new Intl.NumberFormat();
    useEffect(() => {
        api.start({ value: Number(props.children), immediate: !props.animated });
    }, [api, props.animated, props.children]);
    return (React.createElement(StyledStatNumber, { "data-role": "stat-number" }, styles.value.to((x) => formatter.format(Number(x.toFixed())))));
};
export const StatHelpText = (props) => {
    return (React.createElement(StyledStatHelpText, { "data-role": "stat-help", type: props.type },
        arrows[props.type],
        props.children));
};
export const Stat = (props) => {
    return (React.createElement(StyledStat, { className: cx('stat', props.className), "data-role": "stat" }, props.children));
};
